import { useState } from 'react'
import Lightbox from 'yet-another-react-lightbox'
import Photo from './Photo'
import EmptyState from './EmptyState'
import Header from './Header'

const PhotoLibrary = ({ photos, search, selectedPhotos, handlePhotoSelectionToggle, showHeader, adAssets }) => {
    const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(-1)

    let filteredPhotos = photos
    if (search) {
        filteredPhotos = photos
            .filter((x) => x.name)
            .filter((photo) =>
                String(photo.name || '')
                    .toLowerCase()
                    .includes(search.toLowerCase()),
            )
    }

    const slides = filteredPhotos.map((photo) => ({ src: photo.url }))

    return (
        <div>
            {showHeader && <Header title="Photos" />}
            <div>
                {filteredPhotos.length === 0 && <EmptyState type="photos" />}

                {filteredPhotos.length !== 0 && (
                    <div className="d-flex flex-wrap gap-3">
                        {filteredPhotos.map((photo, index) => (
                            <Photo
                                key={`${photo.id}-${index}`}
                                photo={photo}
                                adAssets={adAssets}
                                selected={selectedPhotos.includes(photo.id)}
                                onPhotoSelect={() => setSelectedPhotoIndex(index)}
                                handlePhotoSelectionToggle={handlePhotoSelectionToggle}
                            />
                        ))}
                    </div>
                )}
            </div>

            <Lightbox
                slides={slides}
                index={selectedPhotoIndex}
                open={selectedPhotoIndex !== -1}
                close={() => setSelectedPhotoIndex(-1)}
                styles={{
                    container: {
                        backgroundColor: 'rgba(0, 0, 0, .8)',
                        backdropFilter: 'blur(3px)',
                    },
                }}
            />
        </div>
    )
}

export default PhotoLibrary
